<template>
  <div>
    <question id="1" :title="$t('questions.measure')">
      <input-measure v-model="value.size" image="coat-hanger-box/coat-hanger-measure.png" />
    </question>
    <question id="2" :title="$t('questions.internalOrExternalSizes')" class="mt-2">
      <input-internal-or-external v-model="value.externalSize" />
    </question>
    <question id="3" :title="$t('questions.boxOpening')" class="mt-2">
      <input-coat-hanger-box-opening v-model="value.opening" />
    </question>
    <question id="4" :title="$t('questions.printType')" class="mt-2">
      <input-print-type v-model="value.printing" />
    </question>
    <question id="5" :title="$t('questions.supports')" class="mt-2">
      <input-coat-hanger-internal-support v-model="value.internalSupports" />
    </question>
    <question id="6" :title="$t('questions.boxAmount')" class="mt-2">
      <input-amount v-model="value.amount" />
    </question>
    <question id="7" :title="$t('questions.additionalNotes')" class="mt-2">
      <input-additional-notes v-model="value.additionalNotes" />
    </question>
  </div>
</template>
<script>
import InputCoatHangerBoxOpening from '../inputs/coat-hanger/InputCoatHangerBoxOpening'
import InputCoatHangerInternalSupport from '../inputs/coat-hanger/InputCoatHangerInternalSupport'
import { ProductMixin } from './Product.mixin'

export default {
  name: 'CoatHangerBox',
  components: { InputCoatHangerInternalSupport, InputCoatHangerBoxOpening },
  mixins: [ProductMixin]
}
</script>
